import React, { useEffect } from 'react'
import { getServersData } from '../../actions/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import { IoIosCheckmark, IoIosClose } from "react-icons/io";
import moment from 'moment'


const Servers = () => {
  
  const dispatch = useDispatch()
  const { servers, loading } = useSelector(state => state.dashboard)


  useEffect(() => {
    dispatch(getServersData())
  }, [dispatch])
  
  if (loading) return <Loader/>;

  const formattedDate = (date) => date ? moment(date).format('DD.MM.YYYY HH:mm:ss') : '';

  const renderRow = (item) => {

    return (
      <tr key={item.id}>
        <td>{item.name}</td>
        <td>{item.hostglobal}</td>
        <td>{item.id}</td>
        <td>{item.port}</td>
        <td>{item.db}</td>
        <td>{!!item.status ? <IoIosCheckmark color='#00d900' size={36}/> : <IoIosClose color='red' size={36}/>}</td>
        <td>{}</td>
        <td>{formattedDate(item.time_good)}</td>
        <td>{formattedDate(item.time_bad)}</td>
        <td>{formattedDate(item.lastbackup_date)}</td>
        <td>{item.lastbackup_size}</td>
        <td>{formattedDate(item.lastlogin)}</td>
      </tr>
    )
  }

  return (
    <section>
      <Table maxHeight='90vh'>
        <thead>
          <tr>
            <th>Наименование</th>
            <th>Глобал, IP</th>
            <th>id</th>
            <th>Порт</th>
            <th>База данных</th>
            <th>LMS</th>
            <th>Версия программы</th>
            <th>Успешное подкл.</th>
            <th>Неудачное подкл.</th>
            <th>Бэкап дата</th>
            <th>Бэкап размер</th>
            <th>Последний вход</th>
          </tr>
        </thead>
        <tbody>
          {servers?.map(renderRow)}
        </tbody>
      </Table>
    </section>
  )
}

export default Servers